import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import PaginatedTable from "Components/Tables/PaginatedTable";
import useTableFilters from 'helpers/hooks/useTableFilters';
import { getLocations, deleteLocation, updateLocation, createLocation } from 'helpers/API Calls/System & Settings/Locations';
import Spinner from 'Components/UI/Spinner';
import convertDateFormat from 'Components/Date/DateFormat';
import { generateQueryParams } from 'helpers/queryParams';
import DeleteModal from "Components/Modals/DeleteModal";
import ModalWrapper from 'Components/Modals/ModalWrapper';

const tableHead = [
  { id: 1, name: "#", isSortable: true, key: "id" },
  { id: 2, name: "Name", isSortable: true, key: "location_name" },
  { id: 5, name: "Created", isSortable: true, key: "created_at" },
  { id: 6, name: "Updated", isSortable: true, key: "updated_at" },
  { id: 7, name: "Actions", isSortable: false, key: "actions" }
];

function LocationsListing() {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [modal, setModal] = useState<boolean>(false)
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();
  
  const fetchData = async () => {
    setIsLoading(true);
    const response = await getLocations(generateQueryParams(filters));
    if (response.success) {
      setData(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item: any) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteLocation(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };
  const handleFromSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(form);
    const data = {
        location_name: formData.get('location_name'),
    }
    const response = selectedItem 
      ? await updateLocation(selectedItem.id, data) 
      : await createLocation(data);
    
    if (response.success) {
      setModal(false);
      setSelectedItem(null);
      fetchData();
    }
  }

  return (
    <>
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Locations", link: "/location" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinner/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={tableHead}
              pagination={pagination}
              isAddModal={true}
              buttonText="Add New Location"
              onAddClick={() => {setModal(true)}}
              updateFilter={updateFilter}
              filters={filters}
              > 
              {data.length > 0 && data.map((item) => (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.location_name}</td>
                  <td>{convertDateFormat(item.created_at)}</td>
                  <td>{convertDateFormat(item.updated_at)}</td>
                  <td>
                    <div>
                      <button className="btn btn-primary btn-sm me-1" onClick={() => {setSelectedItem(item); setModal(true);}}>
                        <i className="mdi mdi-pencil"></i>
                      </button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}>
                        <i className="mdi mdi-trash-can-outline"></i>
                      </button>
                    </div>
                  </td>
                </tr>))
              }
              {!isLoading && data.length === 0 && <tr className="text-center"><td colSpan={tableHead.length} className="text-danger">No Data Found</td></tr>}
            </PaginatedTable>
          </CardBody>
        </Card>}
      </Container>
    </div>
    {deleteModal && <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`${selectedItem?.location_name} location?`}
    />}
    {modal && <ModalWrapper
        show={modal}
        onCloseClick={() => {setModal(false); setSelectedItem(null)}}
        title={selectedItem ? "Edit Location" : "Add New Location"}
        body={
            <form onSubmit={handleFromSubmit} autoComplete="off">
                <div className="mb-3">
                    <label htmlFor="location_name" className="form-label">Location Name <span className="text-danger">*</span></label>
                    <input
                        type="text"
                        className="form-control"
                        id="location_name"
                        name="location_name"
                        defaultValue={selectedItem ? selectedItem.location_name : ""}
                        required
                    />
                </div>
                <div className="text-end">
                    <button type="button" className="btn btn-secondary me-2" onClick={() => {setModal(false); setSelectedItem(null)}}>Cancel</button>
                    <button type="submit" className="btn btn-primary">{selectedItem ? "Update Location" : "Add Location"}</button>
                </div>
            </form>
        }
        />}
    </>
  );
}

export default LocationsListing;
